<template>
  <section class="success-header">
    <div class="success-header__row" @click="dataLayerPush()">
      <img
        :src="require('@/assets/img/success-ladder/Logotype.svg')"
        class="success-header__logo"
        alt="herbalife logo"
      />
    </div>
  </section>
</template>

<script>
export default {
  name: 'SuccesHeader',
  methods: {
    dataLayerPush() {
      if (this.$gtm) {
        this.$gtm.push({
          event: 'wall_logo',
        })
      }
      this.$router.push(this.helpers.buildRoute({ name: 'Home' }))
    },
  },
}
</script>

<style scoped>
.success-header {
  position: relative;
  background: transparent;
  box-sizing: border-box;
  width: 100%;
  z-index: 6;
}
.success-header__row {
  width: 100%;
  display: flex;
  justify-content: center;
}
.success-header__logo {
  display: block;
  /* width: 200px; */
  height: 60px;
  object-fit: cover;
  object-position: center;
}
</style>
